import type { VisualizationProps } from './types';

/**
 * BalconySVG — балкон: узкий вертикальный шкаф рядом с балконным окном.
 * Зоны: facade, corpus, handles. Без countertop/hooks. Конвенции — `./types.ts`.
 */
export function BalconySVG({ facadeColor, corpusColor, handlesColor }: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      {/* Окно (decorative) */}
      <rect
        x="60"
        y="20"
        width="180"
        height="80"
        fill="#d8e8f0"
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <line x1="150" y1="20" x2="150" y2="100" stroke="#000000" strokeWidth="1" />
      <line x1="60" y1="60" x2="240" y2="60" stroke="#000000" strokeWidth="0.5" />
      <rect
        data-testid="zone-corpus"
        x="240"
        y="40"
        width="60"
        height="145"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="246"
        y="46"
        width="48"
        height="133"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="278"
        y="108"
        width="2"
        height="12"
        fill={handlesColor}
        rx="1"
      />
      <text
        x="270"
        y="115"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="228"
        y="115"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
    </svg>
  );
}
